riot.tag2('bbc-notifications-onboarding-u13-success', '<div class="notifications__container"> <div class="notifications-banner--row"> <span><i1-8n>copy.under13.done</i1-8n></span> <button class="notifications-banner--close" onclick="{parent.hideU13Success}"> <img riot-src="{this.basePath + \'/svg/close_icon.svg\'}" alt="Close"> </button> </div> </div>', '', '', function(opts) {
"use strict";

this.basePath = opts.mainApp.basePath;
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-onboarding-u13-success.tag
 ** module id = 27
 ** module chunks = 0
 **/